import { IUserInfo } from '../shared/core/user-info.model';
import { IUserInProject } from '../shared/core';

export class UsersProject{
    projectId: string;
    users: IUserInProject[];
}

